import React, { useState } from "react";
import "./ContactSection.css";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Logique d'envoi du formulaire
    console.log("Formulaire envoyé:", formData);
  };

  return (
    <section className="contact-section section-padding">
      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-header">
              <h2>Prêt à transformer votre activité ?</h2>
              <p>
                Découvrez comment Monagora peut révolutionner votre gestion de rendez-vous 
                et faire économiser des milliers d'euros à votre entreprise.
              </p>
            </div>
            
            <div className="contact-features">
              <div className="contact-feature">
                <div className="feature-text">
                  <h4>Démarrage rapide</h4>
                  <p>Configuration en moins de 24h</p>
                </div>
              </div>
              
              <div className="contact-feature">
                <div className="feature-text">
                  <h4>Support dédié</h4>
                  <p>Accompagnement personnalisé</p>
                </div>
              </div>
              
              <div className="contact-feature">
                <div className="feature-text">
                  <h4>ROI garanti</h4>
                  <p>Économies dès le premier mois</p>
                </div>
              </div>
            </div>
            
            <div className="contact-stats">
              <div className="stat-item">
                <span className="stat-number">Disponible</span>
                <span className="stat-label">24h/24 et 7j/7</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">Automatisé</span>
                <span className="stat-label">Sans intervention humaine</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">Économique</span>
                <span className="stat-label">Coûts réduits</span>
              </div>
            </div>
          </div>
          
          <div className="contact-form-container">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-header">
                <h3>Demandez une démonstration</h3>
                <p>Un expert vous recontacte sous 24h</p>
              </div>
              
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Votre nom *"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Votre email professionnel *"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <input
                  type="text"
                  name="company"
                  placeholder="Nom de votre entreprise"
                  value={formData.company}
                  onChange={handleChange}
                />
              </div>
              
              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Décrivez vos besoins (optionnel)"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                />
              </div>
              
              <button type="submit" className="form-submit">
                Demander une démonstration
              </button>
              
              <div className="form-footer">
                <p>
                  En soumettant ce formulaire, vous acceptez d'être contacté par notre équipe 
                  commerciale. Vos données sont protégées selon notre politique de confidentialité.
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection; 